module.exports = __webpack_public_path__ + "static/trepakDance-6fcc3a8a11fb772adf5673f66fdea9b2.mp3";